import { Tooltip as MuiToolTip } from '@mui/material'

import {
  tickFormatter,
  svgTextStyle,
  BAR_TEXT_LENGTH,
} from 'components/Shared/Charts/HorizontalBarChart/Constants'
import styles from './HorizontalBarChart.module.scss'

export const formattedText = (name: string) => (
  <div style={{ ...svgTextStyle }}>{tickFormatter(name)}</div>
)

export const CustomizedLabel = (props: any) => {
  return (
    <g
      transform={`translate(${props.maxTextWidth + 5},${props.y + 16})`}
      className={styles.tooltip}
      width={props.maxTextWidth}
    >
      <foreignObject x="-200" y={-16} width="200" height="200" textAnchor="end">
        {props.name.length > BAR_TEXT_LENGTH ? (
          <MuiToolTip
            PopperProps={{
              popperOptions: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      altBoundary: true,
                      tether: false,
                    },
                  },
                ],
              },
            }}
            classes={{ popper: styles.barchartTooltip }}
            title={props.name}
            enterTouchDelay={50}
          >
            {formattedText(props.name)}
          </MuiToolTip>
        ) : (
          formattedText(props.name)
        )}
      </foreignObject>
    </g>
  )
}
